<template>
  <div class="sign-in">
    <p>
      {{
        $t("driver_onboarding.step_progress_bar.step", {
          num: $route.meta.step_id,
        })
      }}
    </p>
    <h1>{{ $t("driver_onboarding.auth.signin") }}</h1>

    <!-- STEP 1 SIGN-IN -->
    <div class="form--sign_in">
      <div class="field">
        <div class="has-prepend">
          <div class="prepend-input">
            <img src="/img/onboard-driver/vn-flag.svg" alt />
            <input value="+84" disabled />
          </div>
          <InputField
            type="text"
            name="mobile"
            :initValue="mobile"
            :labelName="$t('driver_onboarding.auth.mobile')"
            @onChange="onChangeMobile"
            @onSubmit="onSubmit"
          />
        </div>
        <span class="error-mobile" v-if="!!invalidMobileMessage">{{
          invalidMobileMessage
        }}</span>
      </div>
      <b-button :loading="loading" id="re-captcha" @click="onSubmit">{{
        $t("driver_onboarding.auth.submit")
      }}</b-button>

      <div class="button--sign_up">
        <span>{{ $t("driver_onboarding.auth.not_already") }}</span>
        <br />
        <b-button @click="switchSignUp">{{
          $t("driver_onboarding.auth.signup")
        }}</b-button>
      </div>
    </div>

    <!-- END STEP 1 SIGN-IN -->
  </div>
</template>

<script>
import InputField from "@/components/InputField.vue";
import firebaseAuth from "./firebase-auth.mixin";
import { mapGetters } from "vuex";

export default {
  components: {
    InputField,
  },
  mixins: [firebaseAuth],
  data() {
    const id = this.$route.query.id;

    return {
      mobile: id || null,
      invalidMobileMessage: "",
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["supplierToken"]),
    useFirebaseLogin() {
      const authenticateType =
        this.$route && this.$route.query && this.$route.query.authenticate_type;
      return authenticateType !== "ahamove";
    },
  },

  methods: {
    switchSignUp() {
      this.$router.push({
        name: "signup",
      });

      this.$gtag("event", this.$trackingEvents.EVENTS.SWITCH_SIGN_UP, {
        event_category: this.$route.path,
      });
    },
    onChangeMobile(value) {
      if (this.showErrorMobile) {
        this.showErrorMobile = false;
      }
      if (value) {
        var cleanedValue =
          typeof value === "string" ? value.trim() : value.toString();
        const pattern = /^\+\d+$|^\d+$/;
        const isNumber = pattern.test(cleanedValue);
        if (
          isNumber &&
          ((cleanedValue.charAt(0) === "+" && cleanedValue.length > 5) ||
            (cleanedValue.charAt(0) !== "+" && cleanedValue.length > 4)) &&
          cleanedValue.length < 14
        ) {
          this.mobile = value;
        } else {
          this.showErrorMobile = true;
          this.errorMessageMobile = "Số điện thoại không hợp lệ";
        }
      } else {
        this.showErrorMobile = true;
        this.errorMessageMobile = "Vui lòng nhập số điện thoại";
      }
    },
    onSubmit() {
      this.invalidMobileMessage = "";
      if (!this.mobile || this.showErrorMobile) {
        this.$buefy.notification.open({
          message: this.$t(
            "driver_onboarding.auth.validate_msg.invalid_mobile"
          ),
          type: "is-danger",
          duration: 3000,
          position: "is-bottom",
        });
        return;
      }

      const data = {
        mobile: this.mobile,
        resend: false,
      };

      this.loading = true;
      this.$store
        .dispatch("driverLogin", data)
        .then((response) => {
          if (response && response.data && response.status === 200) {
            this.mobile = response.data.id;

            this.handleSignInMethod(response.data.id, response.data.resend);
          }
        })
        .catch((error) => {
          // console.log(error);
          this.loading = false;
          if (error) {
            switch (error.status) {
              case 404:
                if (error.data.title === "Mobile not found") {
                  this.invalidMobileMessage = this.$t(
                    "driver_onboarding.auth.validate_msg.mobile_not_found"
                  );
                }
                break;

              case 406:
                this.invalidMobileMessage = this.$t(
                  "driver_onboarding.auth.validate_msg.invalid_mobile"
                );
                break;

              case 403:
                this.invalidMobileMessage = this.$t(
                  "driver_onboarding.auth.validate_msg.deactivated_account"
                );
                break;

              default:
                if (error.data) {
                  this.invalidMobileMessage = error.data.description;
                } else {
                  // show FIREBASE's error
                  this.invalidMobileMessage = error.message;
                }
            }
          }
        });
    },
    redirectToActivatePage(id, authenticate_type) {
      const currentQuery = this.$route.query;
      this.$setCookie(
        "timer",
        JSON.stringify({
          id,
          start: new Date(),
        })
      );
      this.$router.push({
        name: "activate",
        query: { ...currentQuery, id, authenticate_type },
      });
    },

    handleSignInMethod(mobile, authenticate_type) {
      this.loading = true;
      switch (authenticate_type) {
        case this.$constants.AUTHENTICATE_TYPE.FIREBASE:
          this.$_firebaseAuth_sendOTP(mobile)
            .then((firebase_confirmation) => {
              this.$store.dispatch(
                "setFirebaseConfirmation",
                firebase_confirmation
              );
              this.redirectToActivatePage(mobile, authenticate_type);
            })
            .catch((e) => {
              this.$buefy.notification.open({
                message: e,
                type: "is-danger",
                duration: 3000,
                position: "is-bottom",
              });
              this.loading = false;
              this.redirectToActivatePage(
                mobile,
                this.$constants.AUTHENTICATE_TYPE.AHAMOVE
              );
              this.$store.dispatch("driverLogin", {
                mobile: this.mobile,
                resend: false,
              });
            });
          break;
        default:
          this.redirectToActivatePage(mobile, authenticate_type);
        // this.handleSignInByAhamove(mobile);
      }
    },

    handleResendOTP() {
      if (this.isSignInFirebase) {
        this.initInvisibleRecapcha();
        this.onSubmit();
      } else {
        this.onSubmit();
      }
    },

    updateRedirectUriToQuery() {
      const redirectUri = encodeURIComponent(
        this.$router.history._startLocation
      );

      if (this.$router.history._startLocation !== "/help-center/delete-account")
        return;

      const currentQuery = { ...this.$route.query };

      if (!currentQuery.redirect_uri) {
        currentQuery.redirect_uri = redirectUri;

        this.$router.push({ name: this.$route.name, query: currentQuery });
      }
    },
  },
  mounted() {
    if (this.supplierToken) {
      this.$router.push({ name: "document" });
    }

    this.updateRedirectUriToQuery();
  },
};
</script>

<style lang="scss" scoped>
.sign-in {
  p:first-child {
    color: #bcbcbc;
    font-size: 16px;
    margin-bottom: 4px;
    font-weight: 500;
  }
  h1 {
    margin: 0 0 40px 0;
    color: #1a1a1a;
  }
  .button {
    width: 150px;
    height: 48px;
    font-weight: 500;
  }
  .form--sign_in {
    width: 300px;
    margin-bottom: 24px;

    .field {
      margin-bottom: 15px;

      .prepend-input {
        display: flex;
        width: 25%;
        padding: 0 10px;

        input {
          background-color: #f2f2f2;
          border: none;
          outline: none;
          font-size: 16px;
          padding: 0 5px;
        }
      }
    }

    .field {
      .has-prepend {
        display: flex;
        background-color: #f2f2f2;
        border-radius: 4px;
        height: 46px;
      }
      .error-mobile {
        font-size: 12px;
        color: #ff5252;
      }
    }

    .button {
      background-color: #ff8200;
      color: #fff;
      border-color: inherit;
      border-radius: 4px;
    }
  }
  .button--sign_up {
    margin-top: 24px;
    span {
      color: #7a8189;
      font-size: 14px;
      margin-bottom: 8px;
    }

    .button {
      background-color: #fff;
      color: #ff8200;
      border-color: #ff8200;
      margin-top: 10px;
      border-radius: 2px;
    }
  }
}
</style>
